module.exports = __webpack_public_path__ + "static/media/loaded_active.5f8dbc85.svg";